import React from 'react';
import { connect } from 'react-redux';
import PerfectScrollbar from 'perfect-scrollbar';

// core components
import routes from '../routes.js';
import TopNavBar from '../components/TopNav/TopNavBar.jsx';
import { getWorkspacePath } from '../utils/workspaceUtils.js';

import { setNewDealModal } from '../store/Deals/index.js';
import { setNewAgentModal } from '../store/Agent/index.js';
import { setAssistant } from '../store/Assistant/index.js';
import { setCtrlPressed } from '../store/Settings/index.js';


let ps;
class Admin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      routesState: routes,
      shouldScrollTop: false,
    };
    this.mainPanelRef = React.createRef();
  }
  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('keyup', this.handleKeyUp);
    if (navigator.platform.indexOf('Win') > -1) {
      document.documentElement.className += ' perfect-scrollbar-on';
      document.documentElement.classList.remove('perfect-scrollbar-off');
      ps = new PerfectScrollbar(this.mainPanelRef.current, { suppressScrollX: true });
      let tables = document.querySelectorAll('.table-responsive');
      for (let i = 0; i < tables.length; i++) ps = new PerfectScrollbar(tables[i]);
    }

    let role = localStorage.getItem('role');
    let routesState = this.state['routesState'];

    if (role == 'agent') {
      let remove = ['Campaign', 'Accounts', 'Users'];
      routesState = routesState.filter(({ name }) => !remove.includes(name));
    }

    // Filter admin routes - only show for admin users
    if (role !== 'admin') routesState = routesState.filter(route => !route.adminOnly);
    this.setState({ routesState });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('keyup', this.handleKeyUp);
    if (navigator.platform.indexOf('Win') > -1) {
      ps.destroy();
      document.documentElement.className += ' perfect-scrollbar-off';
      document.documentElement.classList.remove('perfect-scrollbar-on');
    }
  }

  componentDidUpdate(e) {
    if (e.history.action === 'PUSH') {
      if (navigator.platform.indexOf('Win') > -1) {
        let tables = document.querySelectorAll('.table-responsive');
        for (let i = 0; i < tables.length; i++) ps = new PerfectScrollbar(tables[i]);
      }
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      if (this.mainPanelRef.current) this.mainPanelRef.current.scrollTop = 0;
    }
  }

  handleKeyDown = (e) => {
    // Update Ctrl key state

    if (e['ctrlKey'] && !this.props.isCtrlPressed)
      this.props.setCtrlPressed(true);

    // Handle Ctrl+number shortcuts for navigation
    if (e['ctrlKey'] && e['key'] >= '1' && e['key'] <= '9') {
      e.preventDefault();

      let route = routes.find(route => route['shortcut'] === e['key']);
      if (route && this.props['history']) {
        const workspacePath = getWorkspacePath(route['path'], this.props.currentWorkspace?._id);
        this.props['history'].push(workspacePath);
      }
    }

    if (e['key'] === '/' && !this.props['isAssistant']) {
      // Don't trigger if user is typing in an input, textarea, or contenteditable element
      const activeElement = document.activeElement;
      const isTyping = activeElement && ( activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.isContentEditable);
      if (!isTyping) {
        e.preventDefault();
      }
    }

    if (e['key'] === 'Escape') {
      // Close Assistant
      this.props.setAssistant(false);

      // Close Create Deal Modal
      this.props.setNewDealModal(false);

      // Close Create Agent Modal
      this.props.setNewAgentModal(false);
    }
  }

  handleKeyUp = (e) => {
    // Reset Ctrl key state when released
    if (!e['ctrlKey'] && this.props.isCtrlPressed) this.props.setCtrlPressed(false);
  }

  render() {
    return (
      <div className='wrapper wrapper--topnav'>
        <TopNavBar routes={this.state.routesState} />
        <div className='main-panel main-panel--topnav' ref={this.mainPanelRef}>
          <div className='content'>
            {this['props']['children']}
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = { setNewDealModal, setNewAgentModal, setAssistant, setCtrlPressed };
const mapStateToProps = ({ Assistant: { isAssistant }, Auth: { isLoadButton }, Settings: { isCtrlPressed, userDetails, currentWorkspace } }) => ({ isLoadButton, isAssistant, isCtrlPressed, userDetails, currentWorkspace });

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
